import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { StandardFilterToggleChip } from "../../../../../../../shared/components/filters/StandardFilterToggleChip"

const useStyles = makeStyles()(() => ({
    chip: {
        "&&": {
            height: "auto",
            padding: ".75rem .875rem",
        },
    },
}))

type Props = Readonly<{
    isActive: boolean
    count: number
    onToggle: (isActive: boolean) => void
}>

export function NotApprovedToggle({ isActive, count, onToggle }: Props) {
    const { classes } = useStyles()

    return (
        <StandardFilterToggleChip isChecked={isActive} count={count} onChange={onToggle} className={classes.chip}>
            <LocalizedStrict id="meeting-service-production-view-not-approved-toggle">
                <span>Not approved</span>
            </LocalizedStrict>
        </StandardFilterToggleChip>
    )
}
